/** @jsxRuntime classic */
/** @jsx jsx */
import React, { useEffect, useRef } from 'react';
import { jsx, css } from '@emotion/react';
import { useFormikContext } from "formik";
import ChoiceGroup from '../../../Forms/ChoiceGroup';
import FluentSelect from '../../../Forms/FluentSelect';
import CobrandDropDown from '../../Checklist/Checklists/Forms/CobrandDropDown';
import Toggle from "../../../Forms/Toggle";
import { Text } from "@fluentui/react";
import { platformOptions, localizationOptions } from '../Helpers/CopyAndFunctions';

const AudienceFields = ({ countries }) => {
  const { values, setFieldValue } = useFormikContext();
  const previousIsGlobal = useRef(values.onForAllCountries);

  useEffect(() => {
    if (previousIsGlobal.current !== values.onForAllCountries) {
      previousIsGlobal.current = values.onForAllCountries;
      setFieldValue('countries', []);
    }
  }, [values.onForAllCountries, setFieldValue]);
  
  return (
    <>
      <ChoiceGroup
          label="Platform"
          name="platformId"
          options={platformOptions}
          required
      />
      <hr />
      <div css={css`padding-bottom: 30px;`}>
          <Toggle
              name="onForAllCobrands"
              label="Cobrand On/Off Setting"
              onText="On For All Cobrands"
              offText="Off For All Cobrands"
          />
          <Text variant="small">
              If the webinar is {values.onForAllCobrands ? "on" : "off"} for all cobrands, then you can
              set the exceptions below.
          </Text>
          {!values.onForAllCobrands && (
              <CobrandDropDown name='cobrands' label='on for Cobrands' byNameOrId='id' multiSelect />
          )}
      </div>
      <div css={css`padding-bottom: 30px;`}>
          <ChoiceGroup
              label="Country Localization Setting"
              name="onForAllCountries"
              options={localizationOptions}
              required
          />
          <Text variant="small">
              If the webinar is {values.onForAllCountries ? "global" : "not global"}, then you can
              set the exceptions below.
          </Text>
          <FluentSelect
              name='countries'
              label={values.onForAllCountries ? 'Hide From' : 'Show To'}
              options={countries?.map(c => ({ value: c.id, label: c.name }))}
              isMulti
          />
      </div>
    </>
  );
};

export default AudienceFields;
